package com.patronat.top.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import org.jetbrains.compose.resources.DrawableResource
import top.design_system.generated.resources.Res
import top.design_system.generated.resources.ic_alert_circle
import top.design_system.generated.resources.ic_alert_warning
import top.design_system.generated.resources.ic_app_small
import top.design_system.generated.resources.ic_arrow_down
import top.design_system.generated.resources.ic_arrow_left_vector
import top.design_system.generated.resources.ic_arrow_up
import top.design_system.generated.resources.ic_check
import top.design_system.generated.resources.ic_close
import top.design_system.generated.resources.ic_radio_selected
import top.design_system.generated.resources.ic_radio_unselected
import top.design_system.generated.resources.ic_profile
import top.design_system.generated.resources.ic_email
import top.design_system.generated.resources.ic_nav_ai_moderation
import top.design_system.generated.resources.ic_nav_business
import top.design_system.generated.resources.ic_nav_dashboard
import top.design_system.generated.resources.ic_nav_moderators
import top.design_system.generated.resources.ic_nav_review
import top.design_system.generated.resources.ic_nav_settings
import top.design_system.generated.resources.ic_nav_users
import top.design_system.generated.resources.ic_photo
import top.design_system.generated.resources.ic_plus
import top.design_system.generated.resources.ic_plus_circle
import top.design_system.generated.resources.ic_action_3_dot
import top.design_system.generated.resources.ic_search
import top.design_system.generated.resources.ic_filter
import top.design_system.generated.resources.ic_filter_sliders
import top.design_system.generated.resources.ic_heart
import top.design_system.generated.resources.ic_heart_filled
import top.design_system.generated.resources.ic_like
import top.design_system.generated.resources.ic_checkbox_checked
import top.design_system.generated.resources.ic_checkbox_unchecked
import top.design_system.generated.resources.ic_client_action_catalog
import top.design_system.generated.resources.ic_client_action_phone
import top.design_system.generated.resources.ic_client_action_share
import top.design_system.generated.resources.ic_client_action_website
import top.design_system.generated.resources.ic_edit
import top.design_system.generated.resources.ic_block
import top.design_system.generated.resources.ic_unblock
import top.design_system.generated.resources.ic_upload
import top.design_system.generated.resources.ic_file
import top.design_system.generated.resources.ic_tag
import top.design_system.generated.resources.ic_tab_home
import top.design_system.generated.resources.ic_tab_home_filled
import top.design_system.generated.resources.ic_tab_map
import top.design_system.generated.resources.ic_tab_map_filled
import top.design_system.generated.resources.ic_tab_profile
import top.design_system.generated.resources.ic_tab_profile_filled
import top.design_system.generated.resources.ic_tab_saved
import top.design_system.generated.resources.ic_tab_saved_filled
import top.design_system.generated.resources.ic_shield
import top.design_system.generated.resources.ic_notification_bell
import top.design_system.generated.resources.ic_rating_star_filled
import top.design_system.generated.resources.ic_view_venue
import top.design_system.generated.resources.img_logo_transparent
import top.design_system.generated.resources.ic_venue_gallery
import top.design_system.generated.resources.ic_venue_gallery_upload
import top.design_system.generated.resources.ic_venue_location
import top.design_system.generated.resources.ic_venue_main_info
import top.design_system.generated.resources.ic_venue_owner
import top.design_system.generated.resources.ic_venue_schedule
import top.design_system.generated.resources.ic_venue_group_auto
import top.design_system.generated.resources.ic_venue_group_beauty
import top.design_system.generated.resources.ic_venue_group_business
import top.design_system.generated.resources.ic_venue_group_education
import top.design_system.generated.resources.ic_venue_group_entertainment
import top.design_system.generated.resources.ic_venue_group_events
import top.design_system.generated.resources.ic_venue_group_food
import top.design_system.generated.resources.ic_venue_group_health
import top.design_system.generated.resources.ic_venue_group_home
import top.design_system.generated.resources.ic_venue_group_household
import top.design_system.generated.resources.ic_venue_group_it_media
import top.design_system.generated.resources.ic_venue_group_logistics
import top.design_system.generated.resources.ic_venue_group_pets
import top.design_system.generated.resources.ic_venue_group_shopping
import top.design_system.generated.resources.ic_venue_group_travel
import top.design_system.generated.resources.ic_venue_image_placeholder
import top.design_system.generated.resources.ic_venue_moderator_assign

@Composable
private fun iconPainter(
    resource: DrawableResource,
    androidResourceName: String? = null
): Painter = appIconPainter(resource, androidResourceName)

object AppIcons {

    val CheckboxOn: Painter @Composable get() = iconPainter(Res.drawable.ic_checkbox_checked, "ic_checkbox_checked")
    val CheckboxOff: Painter @Composable get() = iconPainter(Res.drawable.ic_checkbox_unchecked, "ic_checkbox_unchecked")

    val AppIconSmall: Painter
        @Composable get() = iconPainter(Res.drawable.ic_app_small)

    val LogoTransparent: Painter
        @Composable get() = iconPainter(Res.drawable.img_logo_transparent)

    val ArrowLeft: Painter
        @Composable get() = iconPainter(Res.drawable.ic_arrow_left_vector, "ic_arrow_left_vector")

    val AlertCircle: Painter
        @Composable get() = iconPainter(Res.drawable.ic_alert_circle, "ic_alert_circle")

    val Profile: Painter
        @Composable get() = iconPainter(Res.drawable.ic_profile, "ic_profile")

    val Email: Painter
        @Composable get() = iconPainter(Res.drawable.ic_email, "ic_email")

    val AlertWarning: Painter
        @Composable get() = iconPainter(Res.drawable.ic_alert_warning, "ic_alert_warning")

    val RadioSelected: Painter
        @Composable get() = iconPainter(Res.drawable.ic_radio_selected, "ic_radio_selected")

    val RadioUnselected: Painter
        @Composable get() = iconPainter(Res.drawable.ic_radio_unselected, "ic_radio_unselected")

    //Navigation
    val NavDashboard: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_dashboard, "ic_nav_dashboard")

    val NavAiModeration: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_ai_moderation, "ic_nav_ai_moderation")
    val NavBusiness: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_business, "ic_nav_business")
    val NavModerators: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_moderators, "ic_nav_moderators")
    val NavSettings: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_settings, "ic_nav_settings")
    val NavUsers: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_users, "ic_nav_users")

    val NavReview: Painter
        @Composable get() = iconPainter(Res.drawable.ic_nav_review, "ic_nav_review")

    // Client bottom tabs
    val TabHome: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_home, "ic_tab_home")
    val TabHomeFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_home_filled, "ic_tab_home_filled")
    val TabMap: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_map, "ic_tab_map")
    val TabMapFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_map_filled, "ic_tab_map_filled")
    val TabSaved: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_saved, "ic_tab_saved")
    val TabSavedFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_saved_filled, "ic_tab_saved_filled")
    val TabProfile: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_profile, "ic_tab_profile")
    val TabProfileFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_tab_profile_filled, "ic_tab_profile_filled")

    val Plus: Painter
        @Composable get() = iconPainter(Res.drawable.ic_plus, "ic_plus")

    val PlusCircle: Painter
        @Composable get() = iconPainter(Res.drawable.ic_plus_circle, "ic_plus_circle")

    val ArrowUp: Painter
        @Composable get() = iconPainter(Res.drawable.ic_arrow_up, "ic_arrow_up")

    val ArrowDown: Painter
        @Composable get() = iconPainter(Res.drawable.ic_arrow_down, "ic_arrow_down")

    val Photo: Painter
        @Composable get() = iconPainter(Res.drawable.ic_photo, "ic_photo")

    val Close: Painter
        @Composable get() = iconPainter(Res.drawable.ic_close, "ic_close")

    val Check: Painter
        @Composable get() = iconPainter(Res.drawable.ic_check, "ic_check")

    val Action3Dot: Painter
        @Composable get() = iconPainter(Res.drawable.ic_action_3_dot, "ic_action_3_dot")

    val Search: Painter @Composable get() = iconPainter(Res.drawable.ic_search, "ic_search")
    val Filter: Painter @Composable get() = iconPainter(Res.drawable.ic_filter, "ic_filter")
    val FilterSliders: Painter @Composable get() = iconPainter(Res.drawable.ic_filter_sliders, "ic_filter_sliders")
    val Heart: Painter @Composable get() = iconPainter(Res.drawable.ic_heart, "ic_heart")
    val HeartFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_heart_filled, "ic_heart_filled")
    val Like: Painter @Composable get() = iconPainter(Res.drawable.ic_like, "ic_like")
    val NotificationBell: Painter @Composable get() = iconPainter(Res.drawable.ic_notification_bell, "ic_notification_bell")
    val RatingStarFilled: Painter @Composable get() = iconPainter(Res.drawable.ic_rating_star_filled, "ic_rating_star_filled")
    val VenueImagePlaceholder: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_image_placeholder, "ic_venue_image_placeholder")

    val ClientActionWebsite: Painter @Composable get() = iconPainter(Res.drawable.ic_client_action_website, "ic_client_action_website")
    val ClientActionPhone: Painter @Composable get() = iconPainter(Res.drawable.ic_client_action_phone, "ic_client_action_phone")
    val ClientActionShare: Painter @Composable get() = iconPainter(Res.drawable.ic_client_action_share, "ic_client_action_share")
    val ClientActionCatalog: Painter @Composable get() = iconPainter(Res.drawable.ic_client_action_catalog, "ic_client_action_catalog")

    val Edit: Painter @Composable get() = iconPainter(Res.drawable.ic_edit, "ic_edit")
    val Block: Painter @Composable get() = iconPainter(Res.drawable.ic_block, "ic_block")
    val Unblock: Painter @Composable get() = iconPainter(Res.drawable.ic_unblock, "ic_unblock")

    val Upload: Painter @Composable get() = iconPainter(Res.drawable.ic_upload, "ic_upload")
    val File: Painter @Composable get() = iconPainter(Res.drawable.ic_file, "ic_file")
    val Tag: Painter @Composable get() = iconPainter(Res.drawable.ic_tag, "ic_tag")
    val Shield: Painter @Composable get() = iconPainter(Res.drawable.ic_shield, "ic_shield")
    val ViewVenue: Painter @Composable get() = iconPainter(Res.drawable.ic_view_venue, "ic_view_venue")

    val VenueOwner: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_owner, "ic_venue_owner")
    val VenueModeratorAssign: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_moderator_assign, "ic_venue_moderator_assign")
    val VenueMainInfo: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_main_info, "ic_venue_main_info")
    val VenueLocation: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_location, "ic_venue_location")
    val VenueSchedule: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_schedule, "ic_venue_schedule")
    val VenueGallery: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_gallery, "ic_venue_gallery")
    val VenueGalleryUpload: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_gallery_upload, "ic_venue_gallery_upload")

    val VenueGroupFood: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_food, "ic_venue_group_food")
    val VenueGroupShopping: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_shopping, "ic_venue_group_shopping")
    val VenueGroupBeauty: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_beauty, "ic_venue_group_beauty")
    val VenueGroupHealth: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_health, "ic_venue_group_health")
    val VenueGroupAuto: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_auto, "ic_venue_group_auto")
    val VenueGroupHome: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_home, "ic_venue_group_home")
    val VenueGroupEducation: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_education, "ic_venue_group_education")
    val VenueGroupBusiness: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_business, "ic_venue_group_business")
    val VenueGroupItMedia: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_it_media, "ic_venue_group_it_media")
    val VenueGroupLogistics: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_logistics, "ic_venue_group_logistics")
    val VenueGroupEntertainment: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_entertainment, "ic_venue_group_entertainment")
    val VenueGroupPets: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_pets, "ic_venue_group_pets")
    val VenueGroupHousehold: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_household, "ic_venue_group_household")
    val VenueGroupEvents: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_events, "ic_venue_group_events")
    val VenueGroupTravel: Painter @Composable get() = iconPainter(Res.drawable.ic_venue_group_travel, "ic_venue_group_travel")
}
